import { NumberInput as MantineNumberInput } from '@mantine/core';
import React from 'react';
import { JiraFieldData2 } from '../../../../api/endpoints/jira';

interface NumberInputProps {
    field: JiraFieldData2;
    value: number | '';
    error?: boolean;
    onChange: (value: number | '') => void;
    onSubmit?: (value: number | '') => void;
}

export const JiraNumberInput = React.memo(({ field, value, error, onChange, onSubmit }: NumberInputProps) => {
    return (
        <MantineNumberInput
            label={field.name}
            placeholder={`Enter ${field.name.toLowerCase()}`}
            required={field.required && !field.hasDefaultValue}
            value={value}
            onChange={onChange}
            onBlur={() => onSubmit(value)}
            hideControls={false}
            allowNegative
            allowDecimal
            error={error}
        />
    );
});
